export class Optional {
    constructor(isPresent, valueIfPresent) {
        this.isPresent = isPresent;
        this.valueIfPresent = valueIfPresent;
    }
    get() {
        if (!this.isPresent) {
            throw new Error("Optional.get() called but isPresent is false");
        }
        return this.valueIfPresent;
    }
    orElse(other) {
        if (this.isPresent)
            return this.valueIfPresent;
        else
            return other;
    }
    toString() {
        if (this.isPresent) {
            return `Optional.of(${this.get()})`;
        }
        else
            return "Optional.empty()";
    }
    static empty() {
        return Optional.emptyInstance;
    }
    static of(value) {
        return new Optional(true, value);
    }
}
Optional.emptyInstance = new Optional(false, undefined);
//# sourceMappingURL=optional.js.map